// src/components/watch/WatchGrid.js
import React from "react";
import PropTypes from "prop-types";
import WatchCard from "./WatchCard";
import "./WatchGrid.css";

const WatchGrid = ({ games, viewMode = "grid", onPlaceBet, onWatchRace }) => {
  if (!games || games.length === 0) {
    return (
      <div className="race-grid-empty">
        <p>No live races available.</p>
      </div>
    );
  }

  return (
    <div className="race-grid-container">
      <div
        className={`race-grid ${
          viewMode === "list" ? "list-view" : "grid-view"
        }`}
      >
        {games.map((game) => (
          <div key={game.id} className="race-grid-item">
            <WatchCard
              race={game}
              onPlaceBet={() => onPlaceBet(game.id)}
              onWatch={() => onWatchRace(game)} // Add watch handler
            />
          </div>
        ))}
      </div>
    </div>
  );
};

WatchGrid.propTypes = {
  games: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      totalPrizePool: PropTypes.number.isRequired,
      elapsedTime: PropTypes.string.isRequired,
      remainingTime: PropTypes.string.isRequired,
      tokens: PropTypes.arrayOf(
        PropTypes.shape({
          symbol: PropTypes.string.isRequired,
          percentChange: PropTypes.number.isRequired,
          position: PropTypes.number.isRequired,
        })
      ).isRequired,
      handicap: PropTypes.string.isRequired,
    })
  ).isRequired,
  viewMode: PropTypes.oneOf(["grid", "list"]),
  onPlaceBet: PropTypes.func.isRequired,
  onWatchRace: PropTypes.func.isRequired, // Add PropTypes for watch handler
};

export default WatchGrid;
